import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

addToChainAfter(chain, RemoveCartLine, async props => {
    // Verndale Customization ticket: DSSM-465
    const product = props.getState().data.carts.byId[props.apiParameter.cartId].cartLines?.find(cl => cl.id === props.apiParameter.cartLineId);

    const result = await getProductCategories({
        productIds: [product?.productId || ''],
        type: "product",
    });

    if (result.successful) {
        const productCategories = result.result;
        const currentPath = window.location.pathname;
        if (currentPath === "/Cart") {
            setGA4Event([product], "remove_from_cart", {productCategories});
        }
    }
    // End of Verndale Customization ticket: DSSM-469
});
